<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel pb-0">
      <div class="filter">
        <el-form
          :inline="true"
          :model="filter"
          ref="filterForm"
          label-position="right"
          label-width="70px"
          class="search-form oneline"
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="关键字">
            <el-input
              v-model="filter.name"
              placeholder="姓名或电话号码"
              @keyup.enter.native="
                filter.page = 1
                getData(false)
              "
            ></el-input>
          </el-form-item>
          <el-form-item label="角色">
            <el-select
              style="width: 100%"
              v-model="filter.role_id"
              size="small"
              placeholder="请选择角色"
            >
              <el-option
                v-for="item in allRoles"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                getData(false)
              "
              >筛选</el-button
            >
            <el-button size="small" @click="getData(true)">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="panel">
      <el-button
        size="small"
        type="primary"
        v-code="11101"
        @click="$router.push('/users/new')"
        >添加用户</el-button
      >
      <user-table :items="users"></user-table>
      <el-pagination
        background
        class="m-t-20 text-right"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData(false)"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { userList, roleList } from '@/service/getData'
import userTable from './table'

export default {
  components: {
    userTable,
  },
  data() {
    return {
      filter: {
        name: '',
        role_id: '',
        page: 1,
        size: 10,
      },
      total: 0,
      users: [],
      allRoles: [],
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
    this.getRoles()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.name = ''
        this.filter.role_id = ''
      }
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1

      let res = await userList(params)
      if (res.status != 0) return false
      this.total = res.data.count
      this.users = res.data.list.map((item) => {
        let arr = []
        item.function_modules.map((i) => {
          arr.push(i.function_module['name'])
        })
        item.function_module_names = arr.length == 0 ? '-' : arr.join(' | ')

        arr = []
        item.roles.map((i) => {
          arr.push(i.role_name)
        })
        item.role_names = arr.length == 0 ? '-' : arr.join(' | ')
        return item
      })
    },
    async getRoles() {
      let res = await roleList()
      if (res.status == 0) {
        this.allRoles = res.data
      }
    },
  },
}
</script>